export function openWithInfo(popupType, popupInfo) {
    return { 
        type: 'LEVEL_POPUP_OPEN_WITH_INFO', 
        payload: {
            type: popupType,
            info: popupInfo
        }
    };
}

export function open(popupType) {
    return { 
        type: 'LEVEL_POPUP_OPEN',
        payload: popupType
    };
}

export function close() {
    return { 
        type: 'LEVEL_POPUP_CLOSE'
    };
}

export function setAllInfo(info) {
    return { 
        type: 'LEVEL_POPUP_SET_ALL_INFO',
        payload: info
    };
}

export function setName(name) {
    return { 
        type: 'LEVEL_POPUP_SET_NAME',
        payload: name
    };
}

export function setDescription(description) {
    return { 
        type: 'LEVEL_POPUP_SET_DESCRIPTION',
        payload: description
    };
}

export function setGoals(goals) {
    return { 
        type: 'LEVEL_POPUP_SET_GOALS',
        payload: goals
    };
}

export function setLevelIndex(index) {
    return { 
        type: 'LEVEL_POPUP_SET_INDEX',
        payload: index
    };
}

export function setOnClose(onClose) {
    return { 
        type: 'LEVEL_POPUP_SET_CLOSE_CALLBACK',
        payload: onClose
    };
}

export function setOnRestart(onRestart) {
    return {
        type: 'LEVEL_POPUP_SET_RESTART_CALLBACK',
        payload: onRestart
    };
}